import { Skeleton } from "@aircall/tractor";

import { SkeletonTagProps } from "./SkeletonTag.decl";

export function SkeletonTag({ h = 18, w = 60 }: SkeletonTagProps) {
  return <Skeleton h={h} w={w} />;
}
